import React, { useState, useEffect } from 'react'
import { Card, CardBody } from 'reactstrap'

import ListTopBar from '../../components/ListTopBar'
import AppointmentsTable from './partials/AppointmentsTable'
import ExportAppointmentsModal from './partials/ExportAppointmentsModal'

import { handleError, parsePagination } from '../../helpers'
import { getAppointments } from './services'

export default function AppointmentsList() {
	const [appointments, setAppointments] = useState(null)
	const [filterType, setFilterType] = useState('id')
	const [filterValue, setFilterValue] = useState('')
	const [filterScope, setFilterScope] = useState('not_canceled')
	const [pagination, setPagination] = useState({page: 1, per_page: 15, total: 0})
	const [showExportModal, setShowExportModal] = useState(false)

	useEffect(() => {
		!appointments && getAppointments({
			...pagination,
			[`filter[${filterType}]`]: filterValue,
			[filterScope ? `filter[${filterScope}]` : 'noscope']: 1,
			include: 'supplier,warehouse,order,vehicleType,warehouseDock,orderDetails',
			sort: '-start_at'
		})
			.then(res => {
				setAppointments(res.data.data)
				setPagination(parsePagination(res))
			})
			.catch(error => handleError(error))
	}, [ appointments, pagination, filterType, filterValue, filterScope ])

	return (
		<React.Fragment>
			<ListTopBar 
				title="Agendamiento de Citas"
				subtitle="Listado de citas agendadas"
				filterType={filterType}
				setFilterType={setFilterType}
				filterValue={filterValue}
				setFilterValue={setFilterValue}
				filterScope={filterScope}
				setFilterScope={setFilterScope}
				reload={() => setAppointments(null)}
				options={[
					{ label: 'Buscar por concecutivo', value: 'id' },
					{ label: 'Buscar por razón social', value: 'supplier.name' },
					{ label: 'Buscar por NIT', value: 'supplier.document' },
					{ label: 'Buscar por Bodega', value: 'warehouse.name' },
                    { label: 'Buscar orden de compra', value: 'order.sku' },
				]}
				scopes={[
					{ label: 'Citas No Canceladas', value: 'not_canceled' },
					{ label: 'Citas Pendientes', value: 'pending' },
					{ label: 'Citas Confirmadas', value: 'confirmed' },
					{ label: 'Citas Canceladas', value: 'canceled' },
					{ label: 'Citas Asistidas', value: 'attended' },
					{ label: 'Citas Completadas', value: 'completed' },
					{ label: 'Citas No Asistidas', value: 'unattended' },
				]}
				ctaText="Exportar"
				handleCtaClick={() => setShowExportModal(true)}
			/>
			<Card>
				<CardBody>
					<AppointmentsTable 
						appointments={appointments}
						reload={() => setAppointments(null)}
						pagination={pagination}
						setPagination={setPagination}
					/>
				</CardBody>
			</Card>
			{ showExportModal && (
				<ExportAppointmentsModal
					visible={showExportModal}
					onClose={() => setShowExportModal(false)}
				/>
			)}
		</React.Fragment>
	)
}